function IsAdmin(userRights) { return userRights == 9 ? true : false }
function IsManager(userRights) { return userRights >= 3 ? true : false }
function IsUser(userRights) { return userRights == 2 ? true : false }
function IsViewer(userRights) { return userRights == 1 ? true : false }
export { IsAdmin, IsManager, IsUser, IsViewer }